module.exports = __webpack_public_path__ + "img/1543697808.8674491e.jpg";